<template lang="pug">
.chainContainer
  div(@click='selectChain')
    ods-module.modulo.card(:class='{ active: isActive }')
      .text.item.tp-m-micro
        span {{data.descadena}}
      .flecha(:class='{ visible: isVisible , invisible: isInvisible }')
        //- se quita por problemas en varios navegadores
        //- div
        //-   curve-shape-button

  dialog-generic-error(
    :message='errorMessage'
    :dialog-error='dialogError'
    :before-close-fn='handleCloseSession'
    @dialog-closed='closeDialogError($event)')

</template>

<script>
import { EventBusClickonChains } from '../../events-bus'
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import CurveShapeButton from '@/components/cadena/CurveShapeButton'
export default {
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      isActive: false,
      dialogError: false,
      hasErrors: false,
      errorMessage: '',
      isVisible: false,
      isInvisible: true
    }
  },
  methods: {
    selectChain () {
      if (this.$route.query.cadena === undefined) {
        for (var i = document.getElementsByClassName('modulo').length - 1; i >= 0; i--) {
          document.getElementsByClassName('modulo')[i].classList.remove('active')
          document.getElementsByClassName('flecha')[i].classList.remove('visible')
          document.getElementsByClassName('flecha')[i].classList.add('invisible')
          this.redirectbutton = false
        }
        document.getElementsByClassName('modulo')[this.data.registro_Numero - 1].classList.add('active')
        document.getElementsByClassName('flecha')[this.data.registro_Numero - 1].classList.remove('invisible')
        document.getElementsByClassName('flecha')[this.data.registro_Numero - 1].classList.add('visible')
        this.redirectbutton = true
        this.isActive = true
        this.$store.dispatch('listCommercial', this.data).then(r => {
          if (r.error === true) {
            this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          }
        }).catch(e => {
          console.error('Error in confirm token - App', e)
        })
      }
    },
    selectChainRedirect () {
      this.$router.push({ path: '/cadena/' + this.data.registro_Numero, query: { cadena: this.data } })
    },
    selectFirstChainMethod () {
      if (this.data.registro_Numero === 1) {
        document.getElementsByClassName('modulo')[0].classList.add('active')
        document.getElementsByClassName('flecha')[this.data.registro_Numero - 1].classList.remove('invisible')
        document.getElementsByClassName('flecha')[this.data.registro_Numero - 1].classList.add('visible')
        this.isActive = true
        this.$store.dispatch('listCommercial', this.data).then(r => {
          if (r.error === true) {
            this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          }
        }).catch(e => {
          console.error('Error in confirm token - App', e)
        })
      }
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    }
  },
  components: {
    DialogGenericError,
    CurveShapeButton
  },
  mounted () {
    EventBusClickonChains.$on('selectFirstChain', () => {
      this.selectFirstChainMethod()
    })
  },
  beforeDestroy () {
    EventBusClickonChains.$off('selectFirstChain')
  }
}
</script>

<style lang='scss' scoped>
  /deep/ .ods-module__body {
    padding: 0px;
    margin: 0;
    border: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .active {
    &.card {
      border: solid 2px $--color-primary;
      &:hover {
        border: solid 2px $--color-primary;
      }
    }
  }

  .visible {
    display: block
  }

  .invisible {
    display: none
  }

  .text {
    text-align: center;
    padding: rem(16);
  }

  .chainContainer {
    margin: rem(16) rem(24) rem(16) 0;
  }

  .card {
    width: rem(146);
    height: rem(60);
    border: solid 2px $--color-white;
    &:hover {
      border: solid 2px $--color-primary-light-9;
      background: $--color-primary-light-9;
    }
  }

</style>
